import { IHealthProcedures as IGlobalHealthProcedures } from '~/interfaces'

export enum EBirthReportCode {
  GESTATIONAL_AGE_AT_BIRTH_ID = 21102862,
  BIRTH_WEIGHT_ID = 22042165,
  BIRTH_HEIGHT_ID = 22042170,
  HEAD_CIRCUMFERENCE_ID = 22042207,
  CHEST_CIRCUMFERENCE_ID = 22042215,
  FETAL_POSITION_ID = 49259865,
  APGAR_1_MIN_ID = 49234004,
  APGAR_5_MIN_ID = 49236922,
  APGAR_10_MIN_ID = 49480163,
  NEWBORN_COMPLICATIONS_ID = 49451586
}

export interface IGetBirthReportParams {
  pathParams: {
    patientId: string
  }
}

export interface BirthProperty {
  name: string
  result: string
  code: EBirthReportCode
}

export interface IBirthReport {
  properties: BirthProperty[]
}

export interface BabyGrowthPercentiles {
  3: number[]
  15: number[]
  50: number[]
  85: number[]
  97: number[]
}

export interface BabyGrowthMeasurement {
  value: number
  date: string
}

// eslint-disable-next-line @typescript-eslint/no-namespace
export declare namespace ITimelineMaternalInfant {
  interface IBirthIdentifier {
    isBirthAdmission: boolean
    birthDate: string
  }

  interface IHealthProcedures extends IGlobalHealthProcedures, Partial<IBirthIdentifier> {}

  interface IBirthAdmission extends IGlobalHealthProcedures, IBirthIdentifier {
    healthProcedures: IGlobalHealthProcedures[]
  }

  export interface IRowSlotsWrapper {
    id: string
    date: string
    rowSlots: IGlobalHealthProcedures[]
  }

  interface IDailyTimelineData {
    timelineId: number
    days: IRowSlotsWrapper[]
  }

  interface IWeeklyTimelineData {
    timelineId: number
    months: Array<{
      id: string
      date: string
      weeksRowSlotsTotal: number
      weeks: IRowSlotsWrapper[]
    }>
  }

  interface IWeeksRowSlotsWrapper {
    id: string
    rowSlots: IHealthProcedures[]
  }

  interface ITrimesterRowSlotsWrapper {
    id: string
    totalSlots: number
    weeks: IWeeksRowSlotsWrapper[]
  }

  interface ITrimesterTimelineData {
    timelineId: number
    trimester: ITrimesterRowSlotsWrapper[]
  }

  type Baby = 'baby'
  type Mother = 'mother'
  type Pediatric = 'pediatric'
  type PatientType = Baby | Mother | Pediatric
}
